import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';


class OurLogo extends React.Component<any, any> {

    render() {
        let content = <div></div>;

        if (this.props.aboutUsSettings && !this.props.isLoading) {
            content = <InlineTextDisplay source={this.props.aboutUsSettings.logoHtmlText} />
        }

        return content;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutUsSettings: state.siteData.siteData.aboutUsSettings,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const OurLogoContainer = connect(mapStateToProps, mapDispatchToProps)(
    OurLogo
);

export default OurLogoContainer;


// WEBPACK FOOTER //
// ./src/components/AboutUs/OurLogo.tsx